<div class="row animated fadeIn">
   <div class="col-md-12">
      <div class="d-flex justify-content-between align-items-center mb-2">
         <h4 class="mb-0" *ngIf="dollar==true"><a href="javascript:void(0);" (click)="view()"><span
                  class="mdi mdi-arrow-left"></span></a>
            Details Inquiry / Edit Product</h4>
         <h4 class="mb-0" *ngIf="dollar==false"><a href="javascript:void(0);" (click)="view()"><span
                  class="mdi mdi-arrow-left"></span></a>
            Details Inquiry / Add Product</h4>
      </div>

      <div class="card" style="margin-bottom:260px;">
         <div class="card-body">
            <form [formGroup]="registerForm">
               <div class="row py-1 odd w-100 m-0">
                  <div class="col-lg-8 col-sm-12 px-1">
                     <div class="row w-100 m-0">
                        <label class="col-sm-3 col col-form-label p-1">Project Name:<br>(Project ID)</label>
                        <div class="col-sm-9 col">
                           <p class="view-value">{{formdata.ProjectName}} ({{formdata.ProjectNumber}})</p>
                        </div>
                     </div>
                  </div>
                  <div class="col-lg-4 col-sm-12 px-1">
                     <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label p-1">Business Vertical:</label>
                        <div class="col-sm-8 col">
                           <p class="view-value">{{formdata.BusinessVerticalName}}</p>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="row  py-1 odd w-100 m-0">
                  <div class="col-lg-8 col-sm-12 px-1">
                     <div class="row w-100 m-0">
                        <label class="col-sm-3 col col-form-label p-1">Inquiry Name:<br>(Inquiry ID)</label>
                        <div class="col-sm-9 col">
                           <p class="view-value">{{formdata.InquiryName}} ({{formdata.InquiryNumber}})</p>
                        </div>
                     </div>
                  </div>
                  <div class="col-lg-4 col-sm-12 px-1">
                     <div class="row w-100 m-0">
                        <label class="col-sm-4 col col-form-label p-1">Receive Date:</label>
                        <div class="col-sm-8 col">
                           <p class="view-value">{{formdata.ReceivedDate}}</p>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="form-row">
                  <div class="col-sm-12">
                     <div class="form-row">
                        <label for="" class="d-flex align-items-center col-md-4">Base Currency Rate<span
                              class="required">*</span>
                        </label>
                        <label for="" class="d-flex col-md-3">Reported
                        </label>
                     </div>
                     <div class="form-row">
                        <div class="col-md-1">
                           <input class="form-control text-right" style="padding-right: 10px !important;" type="text"
                              readonly value="1" />
                        </div>
                        <div class="col-md-2" *ngIf="dollar==false">
                           <angular2-multiselect [data]="showCurrency" [(ngModel)]="selectedCurrency"
                              [settings]="CurrencySetting" [ngClass]="{ 'is-invalid': submitted1 && f.Currency.errors}"
                              (onSelect)="onCurrencySelect($event)" (onDeSelect)="onCurrencySelect($event)"
                              formControlName="Currency" fixSearchBug (input)="NameSpaceNotAllowed($event)">
                           </angular2-multiselect>
                           <div *ngIf="submitted1 && f.Currency.errors" class="invalid-feedback">
                              <div *ngIf="f.Currency.errors.required">Currency is required</div>
                           </div>
                        </div>
                        <div class="col-md-2" *ngIf="dollar==true">
                           <input class="form-control text-right" type="text" formControlName="Currency"
                              [(ngModel)]="currency" readonly />
                        </div>

                        <div class="col-md-1" *ngIf="dollar==false">
                           <input class="form-control text-right" style="padding-right: 10px !important;" type="text"
                              appTwoDigitDecimaNumber min="0" formControlName="ReportedCurrencyRate"
                              [ngClass]="{ 'is-invalid': submitted1 && f.Currency.errors}" maxlength="8"
                              (keyup)="getValue($event); totalsum()"
                              (keypress)="preventDecimalInput($event,'ReportedCurrencyRate')" ondrop="return false;" />
                           <div *ngIf="submitted1 && f.ReportedCurrencyRate.errors" class="invalid-feedback">
                              <div *ngIf="registerForm.get('ReportedCurrencyRate').invalid && 
                                    registerForm.get('ReportedCurrencyRate').errors && 
                                       (registerForm.get('ReportedCurrencyRate').dirty || 
                                         registerForm.get('ReportedCurrencyRate').touched) || submitted1">
                                 <div *ngIf="f.ReportedCurrencyRate.errors.required">Reported Currency Rate is required
                                 </div>
                              </div>
                           </div>
                           <div *ngIf="registerForm.get('ReportedCurrencyRate').invalid && 
                                registerForm.get('ReportedCurrencyRate').errors && 
                                   (registerForm.get('ReportedCurrencyRate').dirty || 
                                      registerForm.get('ReportedCurrencyRate').touched) || submitted1">
                              <small class="text-danger"
                                 *ngIf="registerForm.get('ReportedCurrencyRate').hasError('max')">
                                 Currency can't be greater than 99999.99
                              </small>
                           </div>
                        </div>

                        <div class="col-md-1" *ngIf="dollar==true">
                           <input class="form-control text-right" type="text" formControlName="ReportedCurrencyRate"
                              readonly />
                        </div>

                        <div class="col-md-1">
                           <input class="form-control" type="text" readonly value="QAR" />
                        </div>

                        <div class="row justify-content-start mb-2 zIndexUp" *ngIf="dollar==false">
                           <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0">
                              <li class="pt-1">
                                 <button href="javascript:void(0);" class="btn btn-sm btn-light-info"
                                    (click)="currencySave()">
                                    <span class="mdi mdi-content-save"></span>Save
                                 </button>
                              </li>
                           </ul>
                        </div>
                        <div class="row justify-content-start align-items-center mb-2 zIndexUp" *ngIf="dollar==true">
                           <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0">
                              <li class="pt-1">
                                 <a href="javascript:void(0);"
                                    class="btn btn-sm btn-light-info bg-info border-info w-100 mt-0"
                                    (click)="currencyEdit()"><span class="mdi mdi-pencil"></span>
                                    Edit
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
               
               <div class="form-row px-1">
                  <div class="table-responsive">
                     <table class="table table-bordered mt-3 mytable" aria-hidden="true">
                        <thead class="thead-light">
                           <tr>
                              <th class="font-weight-bold"></th>
                              <th class="font-weight-bold" style="min-width: 90px;">
                                 Business<br>Vertical
                                 <span class="required">*</span>
                              </th>
                              <th class="font-weight-bold" style="min-width: 90px;">
                                 Business<br>Category
                                 <span class="required">*</span>
                              </th>
                              <th class="font-weight-bold" style="min-width:120px;max-width:140px;">Brand</th>
                              <th class="font-weight-bold" style="min-width:163px;max-width:180px;">Model / Item
                                 Code<span class="required">*</span>
                              </th>
                              <th class="font-weight-bold" style="min-width:120px; max-width: 150px;">Origin</th>
                              <th class="font-weight-bold" style="max-width:100px;">Spec.</th>
                              <th class="font-weight-bold" style="min-width:70px;">Qty <span class="required">*</span>
                              </th>
                              <th class="font-weight-bold" style="min-width:89px;">Unit Type <span
                                    class="required">*</span></th>
                              <th class="font-weight-bold" style="min-width:91px;max-width: 91px;">Unit Price <span
                                    class="required">*</span></th>
                              <th class="font-weight-bold">GROSS VALUE <span class="required">*</span></th>
                              <th class="font-weight-bold" style="min-width:100px;max-width:220px;">DISCOUNT RATE
                                 %<br>& Amt
                              </th>
                              <th class="font-weight-bold" style="min-width:180px;min-width:125px;">TOTAL w/o VAT
                                 <span class="required">*</span>
                              </th>
                              <th class="font-weight-bold" style="min-width:180px;min-width:125px;">Tax % & Amt
                                 <span class="required">*</span>
                              </th>
                              <th class="font-weight-bold" style="min-width:180px;min-width:125px;">TOTAL PRICE
                                 <span class="required">*</span>
                              </th>
                              <th class="font-weight-bold" style="min-width:80px;" id="">Competitor </th>
                              <th class="font-weight-bold" style="min-width:110px;max-width:180px;">Tag / Remarks
                              </th>
                              <th class="text-center"><span class="mdi mdi-settings"></span></th>
                           </tr>
                        </thead>

                        <tbody *ngIf="isRender">
                           <ng-container formArrayName="ObjInqProduct">
                              <ng-container
                                 *ngFor="let row of registerForm.controls.ObjInqProduct.controls; let i = index">
                                 <tr [formArrayName]="i" *ngIf="row.controls.Status.value==1">
                                    <td class="p-2">
                                       <div class="form-check">
                                          <input type="checkbox" formControlName="checkItem"
                                             class="form-check-input checkbox-lg" style="margin-top: -10px;">
                                       </div>
                                    </td>
                                    <td>
                                       <ng-select [items]="businessVertical" bindValue="id" bindLabel="itemName"
                                          formControlName="BusinessVertical" placeholder="Select Vertical"
                                          [(ngModel)]="vertical[i]" (change)="onBusinessVerticalSelect($event, i)"
                                          [readonly]="!registerForm.controls.ObjInqProduct.controls[i].controls.check.value">
                                       </ng-select>
                                       <div
                                          *ngIf="submitted && registerForm.controls.ObjInqProduct.controls[i].controls.BusinessVertical.errors">
                                          <span style="color: red !important; font-size: 10px">
                                             Vertical is required
                                          </span>
                                       </div>
                                    </td>
                                    <td class="p-2" style="min-width:115px;">
                                       <div
                                          *ngIf="registerForm.controls.ObjInqProduct.controls[i].controls.check.value==false">
                                          <ng-select [items]="businessCategory[i]" bindValue="id" bindLabel="itemName"
                                             formControlName="BusinessCategory" [(ngModel)]="groups[i]"
                                             (change)="onDetailSelect($event, i)" placeholder="Select Category"
                                             [readonly]="true" title="{{CategoryShow}}">
                                          </ng-select>
                                       </div>
                                       <div
                                          *ngIf="registerForm.controls.ObjInqProduct.controls[i].controls.check.value==true">
                                          <ng-select [items]="businessCategory[i]" bindValue="id" bindLabel="itemName"
                                             formControlName="BusinessCategory" [(ngModel)]="groups[i]"
                                             (change)="onDetailSelect($event, i)" placeholder="Select Category"
                                             [readonly]="false" title="{{CategoryShow}}">
                                          </ng-select>
                                       </div>
                                       <div *ngIf="submitted && 
                                     registerForm.controls.ObjInqProduct.controls[i].controls.BusinessCategory.errors">
                                          <span style="color:red !important; font-size: 10px;">
                                             Category is required</span>
                                       </div>
                                    </td>

                                    <td class="p-2" style="min-width:120px;max-width:140px;">
                                       <div
                                          *ngIf="registerForm.controls.ObjInqProduct.controls[i].controls.check.value==false">
                                          <ng-select [items]="productBrand[i]" bindValue="id" bindLabel="itemName"
                                             formControlName="ProductBrandName" [(ngModel)]="brand[i]"
                                             (change)="onBrandSelect($event, productBrand[i], i)"
                                             placeholder="Select Brand" [readonly]="true" title="{{brandShow}}">
                                          </ng-select>
                                       </div>
                                       <div
                                          *ngIf="registerForm.controls.ObjInqProduct.controls[i].controls.check.value==true">
                                          <ng-select [items]="productBrand[i]" bindValue="id" bindLabel="itemName"
                                             formControlName="ProductBrandName" [(ngModel)]="brand[i]"
                                             (change)="onBrandSelect($event, productBrand[i], i)"
                                             placeholder="Select Brand" [readonly]="false" title="{{brandShow}}">
                                          </ng-select>
                                       </div>
                                    </td>

                                    <td class="p-2" style="min-width:163px;max-width:180px;">
                                       <div style="width:89%;float:left;"
                                          *ngIf="registerForm.controls.ObjInqProduct.controls[i].controls.check.value==false">
                                          <ng-select [items]="showmodel[i]" bindValue="id" bindLabel="itemName"
                                             formControlName="Itemcode" [(ngModel)]="items[i]"
                                             (change)="onModelSelect($event, showmodel[i], i)" placeholder="Select Item"
                                             [readonly]="true" title="{{itemShow}}">
                                          </ng-select>
                                       </div>
                                       <button type="button" class="btn btn-link p-0" placement="top"
                                          ngbTooltip="{{descript[i]}}">
                                       </button>
                                       <div style="width:89%;float:left;"
                                          *ngIf="registerForm.controls.ObjInqProduct.controls[i].controls.check.value==true">
                                          <ng-select [items]="showmodel[i]" bindValue="id" bindLabel="itemName"
                                             formControlName="Itemcode" [(ngModel)]="items[i]"
                                             (change)="onModelSelect($event, showmodel[i], i)" placeholder="Select Item"
                                             [readonly]="false" title="{{itemShow}}">
                                          </ng-select>
                                       </div>
                                       <button type="button" class="btn btn-link p-0" placement="top"
                                          ngbTooltip="{{descript[i]}}">
                                          <span class="mdi mdi-help-circle text-dark"></span>
                                       </button>
                                       <div *ngIf="submitted && 
                                           registerForm.controls.ObjInqProduct.controls[i].controls.Itemcode.errors">
                                          <span style="color:red !important; font-size: 10px;"><br>Item is
                                             required</span>
                                       </div>
                                    </td>

                                    <td class="p-2" hidden>
                                       <input type="text" [(ngModel)]="descript[i]" class="form-control   p-1"
                                          formControlName="Description" placeholder={{descript[i]}}
                                          title="{{descript[i]}}" readonly hidden />
                                       <input type="text" class="form-control" [(ngModel)]="productId[i]"
                                          formControlName="ProductId" hidden />
                                       <input type="text" class="form-control" formControlName="Status"
                                          [(ngModel)]="rowvalue[i]" hidden />
                                    </td>

                                    <td>
                                       <ng-select [items]="countryList" bindValue="itemName" bindLabel="itemName"
                                          formControlName="Origin" [(ngModel)]="options[i]" placeholder="Select Origin">
                                       </ng-select>
                                    </td>
                                    <td class="p-2" style="max-width:100px;" *ngIf="BusinessVerticalId == 1">
                                       <select style="width:60px;" class="form-control pl-1" formControlName="Specified"
                                          [(ngModel)]="specified[i]">
                                          <option [value]="item['Id']" *ngFor="let item of showSpecified; index as i;">
                                             {{item['Name']}}</option>
                                       </select>
                                    </td>
                                    <td class="p-2" style="max-width:100px;" *ngIf="BusinessVerticalId != 1">
                                       <input type="text" class="form-control text-right" formControlName="Specified"
                                          style="padding-right: 10px !important;" placeholder="No"
                                          [(ngModel)]="specified[i]" value="false" readonly hidden />
                                       <input type="text" class="form-control text-right"
                                          style="padding-right: 10px !important;" placeholder="No" value="No"
                                          readonly />
                                    </td>

                                    <td class="p-2">
                                       <div>
                                          <input type="text" class="form-control p-1 text-right"
                                             style="padding-right: 10px !important;"
                                             (input)="singleWhiteSpaceAllowed($event);" formControlName="Qty" #Qty
                                             (keyup)="getPrice(i); getTotalPrice(i)" max="99999" maxlength="3"
                                             [ngClass]="{'is-invalid': 
                                    submitted && registerForm.controls.ObjInqProduct.controls[i].controls.Qty.errors}">
                                       </div>
                                    </td>
                                    <td class="p-2" style="width:90px;">
                                       <select class="form-control" formControlName="UnitType" [(ngModel)]="unit[i]">
                                          <option [value]="item['UnitTypeId']"
                                             *ngFor="let item of showUnit; index as i;">
                                             {{item['UnitType']}}</option>
                                       </select>
                                    </td>

                                    <td class="p-2">
                                       <div>
                                          <input type="text" class="form-control p-1 text-right" style="padding-right: 10px  
                                                !important;" maxlength="9" max="999999.99"
                                             (keypress)="itemsFormValidate($event, i,'Price')"
                                             (keyup)="getPrice(i); getTotalPrice(i)" formControlName="Price" #Price
                                             [ngClass]="{'is-invalid': submitted && 
                                              registerForm.controls.ObjInqProduct.controls[i].controls.Price.errors}"
                                             appTwoDigitDecimaNumber (paste)="pasteNumbrother($event, i)"
                                             ondrop="return false;">
                                       </div>
                                    </td>

                                    <td class="p-2">
                                       <span class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                          ngDefaultControl style="padding-right: 2px !important; width: 115px;"
                                          (keyup)="getPrice(i)" type="text" formControlName="GrossValue"
                                          appTwoDigitDecimaNumber min="0" readonly>{{row.value.GrossValue | number :
                                          '1.2-2'}}</span>
                                    </td>

                                    <td class="p-2">
                                       <div class="mb-1">
                                          <input type="text" class="form-control form-control-sm p-1 text-right"
                                             ondrop="return false;"
                                             style="margin-left: 55px; min-width: 62px; max-width:62px;"
                                             formControlName="DiscountPer" maxlength="6"
                                             (keypress)="itemsFormValidate($event, i,'DiscountPer')"
                                             placeholder="{{row.value.DiscountPer}}" max="100"
                                             (keyup)="getPrice(i); getTotalPrice(i)" appTwoDigitDecimaNumber>

                                          <span class="abs_percentage pt-2 pl-1 pr-1">%</span>
                                       </div>
                                       <input type="text" class="form-control form-control-sm p-1 text-right"
                                          style="margin-left: 55px; min-width: 62px; max-width:62px;"
                                          formControlName="TotalDiscountValue" maxlength="9" max="999999.99"
                                          (keypress)="itemsFormValidate($event, i,'TotalDiscountValue')"
                                          (keyup)="getPrice1(i); getTotalPrice(i)" appTwoDigitDecimaNumber>
                                    </td>

                                    <td class="p-2">
                                       <span *ngIf="currency_name != 'QAR'"
                                          class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                          ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                          formControlName="TotalPrice" appTwoDigitDecimaNumber
                                          min="1">{{row.value.TotalPrice | number :
                                          '1.2-2'}} ({{currency_name}})</span>
                                       <span class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                          ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                          formControlName="TotalPriceQAR"
                                          appTwoDigitDecimaNumber>{{row.value.TotalPriceQAR | number :
                                          '1.2-2'}} (QAR)</span>
                                    </td>

                                    <td class="p-2">
                                       <input type="text" class="form-control form-control-sm p-1 text-right"
                                          style="margin-left: 55px; min-width: 62px; max-width:62px;"
                                          formControlName="VatRate" maxlength="6" placeholder="{{row.value.VatRate}}"
                                          max="100" [(ngModel)]="vat[i]"
                                          (keypress)="itemsFormValidate($event, i,'VatRate')"
                                          (keyup)="getTotalPrice(i); getPrice(i)" appTwoDigitDecimaNumber>
                                       <span class="abs_percentage pt-2 pl-1 pr-1">%</span>

                                       <span class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                          style="margin-left: 55px; width:64px;" ngDefaultControl
                                          formControlName="VatValue" appTwoDigitDecimaNumber>{{ row.value.VatValue |
                                          number :
                                          '1.2-2' }}
                                       </span>
                                    </td>

                                    <td class="p-2">
                                       <span *ngIf="currency_name != 'QAR'"
                                          class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                          ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                          formControlName="TotalPriceWithVat"
                                          appTwoDigitDecimaNumber>{{row.value.TotalPriceWithVat |
                                          number :
                                          '1.2-2'}} ({{currency_name}})</span>
                                       <span class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                          ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                          formControlName="TotalPriceQARWithVat"
                                          appTwoDigitDecimaNumber>{{row.value.TotalPriceQARWithVat |
                                          number :
                                          '1.2-2'}} (QAR)</span>
                                    </td>

                                    <td class="p-2 mat-form-field-wrapper-pb-0">
                                       <mat-form-field class="example-full-width" appearance="fill">
                                          <input type="text" placeholder="Competitor"
                                             class="form-control   p-1 example-no-focus" aria-label="text" matInput
                                             [matAutocomplete]="auto" maxlength="100" (input)="NewSearchFun($event,i)"
                                             formControlName="Competitor" maxlength="100">
                                          <mat-autocomplete #auto="matAutocomplete">
                                             <mat-option *ngFor="let option of productGroupHd | async" [value]="option">
                                                {{option}}
                                             </mat-option>
                                          </mat-autocomplete>
                                       </mat-form-field>
                                    </td>
                                    
                                    <td class="p-2">
                                       <input type="text" class="form-control   p-1" formControlName="Remark"
                                          (keyup)="getPrice(i)" maxlength="100">
                                    </td>

                                    <td class="p-1 font-12">
                                       <div ngbDropdown class="d-block list-dropdown-box">
                                          <a href="javascript:void(0);" class="text-center d-block" id="dropdownBasic1"
                                             ngbDropdownToggle> <i class="mdi mdi-dots-vertical mdi-24"></i></a>
                                          <div ngbDropdownMenu aria-labelledby="dropdownBasic1"
                                             class="dropdown-menu-right">
                                             <div class="d-block">
                                                <a href="javascript:void(0);"
                                                   class="btn fs-14 d-flex align-items-center" placement="bottom"
                                                   (click)="duplicate.show(); copyRow(i)">
                                                   <i class="mdi mdi-checkbox-multiple-blank-outline mr-2"></i>
                                                   Duplicate
                                                </a>
                                             </div>
                                             <div>
                                                <a href="javascript:void(0);"
                                                   class="btn fs-14 d-flex align-items-center" placement="bottom"
                                                   (click)="deleteOpenModal(deleteConfirm, i, row.value.InquiryProductId, row.value.Code)">
                                                   <i class="mdi mdi-delete mr-2"></i> Delete
                                                </a>
                                             </div>
                                          </div>
                                       </div>
                                    </td>
                                 </tr>

                              </ng-container>
                           </ng-container>
                           <tr>
                              <td colspan="14" class="text-right">
                                 <span class="font-weight-bold d-flex justify-content-end">
                                    Freight Amount
                                 </span>
                              </td>
                              <td>
                                 <span *ngIf="currency_name != 'QAR'"
                                    class="form-control-plaintext p-0 d-block text-right font-weight-bold">
                                    {{freightCharges | number : '1.2-2'}} ({{ currency_name }})
                                 </span>
                                 <span class="d-flex justify-content-end">
                                    <input type="text" formControlName="FreightAmountQAR"
                                       class="form-control form-control-sm p-1 text-right mr-1"
                                       style="min-width: 62px; max-width: 62px" maxlength="8"
                                       (keypress)="preventDecimalInput($event,'FreightAmountQAR')"
                                       (input)="totalsum()" /><span class="font-weight-bold">(QAR)</span>
                                 </span>
                              </td>
                              <td colspan="3">
                                 <textarea formControlName="FreightRemark" placeholder="Freight Remarks"
                                    class="form-control form-control-sm" maxlength="200"></textarea>
                              </td>
                           </tr>
                           <tr>
                              <td colspan="9">
                                 <div class="row justify-content-start align-items-start mb-2 mt-2 zIndexUp">
                                    <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0 d-flex">
                                       <li> <a href="javascript:void(0);" class="btn btn-sm btn-light-info fs-12"
                                             (click)="Addrow()">
                                             <span class="mdi mdi mdi-plus"></span>
                                             Add More</a>
                                       </li>
                                       <li> <a href="javascript:void(0);" class="btn btn-sm btn-light-info fs-12"
                                             (click)="getCheckedItemList()">
                                             <span class="mdi mdi-checkbox-multiple-blank-outline"></span>
                                             Duplicate</a>
                                          <input #multiDuplicate1 (click)="multiDuplicate.show()" type="hidden">
                                       </li>
                                    </ul>
                                 </div>
                              </td>

                              <td colspan="1" class="font-weight-bold">
                                 TOTAL
                              </td>
                              <td> <span *ngIf="currency_name != 'QAR'"
                                    class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 115px;"
                                    appTwoDigitDecimaNumber>{{QuotedValue | number :
                                    '1.2-2'}} ({{currency_name}})</span>
                                 <span class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 115px;"
                                    appTwoDigitDecimaNumber>{{TotalGrossQAR | number :
                                    '1.2-2'}} (QAR)</span>
                              </td>
                              <td> <span *ngIf="currency_name != 'QAR'"
                                    class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{DiscountValue |
                                    number : '1.2-2'}} ({{currency_name}})</span>
                                 <span class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{TotalDiscountQAR | number :
                                    '1.2-2'}} (QAR)</span>
                              </td>
                              <td> <span *ngIf="currency_name != 'QAR'"
                                    class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{TotalQuotedSalesValue | number
                                    : '1.2-2'}} ({{currency_name}})</span>
                                 <span class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{TotalReportedQuotedSalesValue | number
                                    : '1.2-2'}} (QAR)</span>
                              </td>
                              <td> <span *ngIf="currency_name != 'QAR'"
                                    class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{TotalTaxAmount | number
                                    : '1.2-2'}} ({{currency_name}})</span>
                                 <span class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{TotalTaxAmountQAR | number
                                    : '1.2-2'}} (QAR)</span>
                              </td>
                              <td> <span *ngIf="currency_name != 'QAR'"
                                    class="form-control-plaintext p-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{TotalPricewithVat + freightCharges | number
                                    : '1.2-2'}} ({{currency_name}})</span>
                                 <span class="form-control-plaintext p-0 mt-0 d-block text-right font-weight-bold"
                                    ngDefaultControl style="padding-right: 2px !important; width: 133px;"
                                    appTwoDigitDecimaNumber>{{TotalPricewithVatQAR | number
                                    : '1.2-2'}} (QAR)</span>
                              </td>
                              <td colspan="3"></td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>

               <div class="form-row mt-4">

                  <div class="form-group col-lg-2 col-md-6 col-sm-12">
                     <label for="" class="d-flex align-items-center">Quoted Date<span class="required ml-1">
                           *</span></label>
                     <div class="input-group">
                        <input type="text" class="bg-calender-icon form-control" placeholder="DD-MM-YYYY" bsDatepicker
                           [ngClass]="{ 'is-invalid': submitted && f.QuotedDate.errors}" formControlName="QuotedDate"
                           (keydown)="disableDate()" [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}"
                           [minDate]="minQuoteDate" [maxDate]="maxQuoteDate" (ngModelChange)="newFunc($event)">
                        <div *ngIf="submitted && f.QuotedDate.errors" class="invalid-feedback">
                           <div *ngIf="f.QuotedDate.errors.required">QuotedDate is required</div>
                        </div>
                     </div>
                  </div>

                  <div class="form-group col-lg-2 col-md-6 col-sm-12">
                     <label for="" class="d-flex align-items-center">Exp. Order Date<span class="required ml-1">
                           *</span></label>
                     <div class="input-group">
                        <input type="text" class="bg-calender-icon form-control" placeholder="DD-MM-YYYY" bsDatepicker
                           [minDate]="maxExpDate" (ngModelChange)="newFunc2($event)"
                           [ngClass]="{ 'is-invalid': submitted && f.ExpOrderDate.errors}"
                           formControlName="ExpOrderDate" [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY'}"
                           (keydown)="disableDate()">
                        <div *ngIf="submitted && f.ExpOrderDate.errors" class="invalid-feedback">
                           <div *ngIf="f.ExpOrderDate.errors.required">ExpOrderDate is required</div>
                        </div>
                     </div>
                  </div>

                  <div class="form-group col-lg-2 col-md-6 col-sm-12">
                     <label for="" class="d-flex align-items-center">Quote
                        Margin %<span class="required ml-1">*</span>
                     </label>
                     <input class="form-control" type="text" formControlName="QuoteMargin" appTwoDigitDecimaNumber
                        [ngClass]="{ 'is-invalid': submitted && f.QuoteMargin.errors}" />
                     <div *ngIf="registerForm.get('QuoteMargin').invalid && registerForm.get('QuoteMargin').errors && 
                         (registerForm.get('QuoteMargin').dirty || registerForm.get('QuoteMargin').touched) || 
                          submitted">
                        <small class="text-danger" *ngIf="registerForm.get('QuoteMargin').hasError('max')">
                           Quote margin can not be greater than 100
                        </small>
                     </div>
                     <div *ngIf="registerForm.get('QuoteMargin').invalid && registerForm.get('QuoteMargin').errors && 
                         (registerForm.get('QuoteMargin').dirty || registerForm.get('QuoteMargin').touched) || 
                          submitted">
                        <small class="text-danger" *ngIf="registerForm.get('QuoteMargin').hasError('min')">
                           Quote margin can not be less than 0
                        </small>
                     </div>
                     <div *ngIf="submitted && f.QuoteMargin.errors" class="invalid-feedback">
                        <div *ngIf="f.QuoteMargin.errors.required">QuoteMargin is required</div>
                     </div>
                  </div>

                  <div class="form-group col-lg-2 col-md-6 col-sm-12">
                     <label for="" class="d-flex align-items-center">Delivery Period
                     </label>
                     <angular2-multiselect [data]="showDelivery" [(ngModel)]="selectedDelivery"
                        [settings]="dropdownSetting1" formControlName="DeliveryPeriod"
                        (onSelect)="onDeliverySelect($event)" (onDeSelect)="onDeliverySelect($event)" fixSearchBug>
                     </angular2-multiselect>
                  </div>

                  <div class="form-group col-lg-2 col-md-6 col-sm-12">
                     <label for="" class="d-flex align-items-center">Inco Terms
                     </label>
                     <angular2-multiselect [data]="showInco" [(ngModel)]="selectedInco" [settings]="dropdownSetting6"
                        formControlName="IncoTerms" (onSelect)="onIncoSelect($event)"
                        (onDeSelect)="onIncoSelect($event)" fixSearchBug>
                     </angular2-multiselect>
                  </div>

                  <div class="form-group col-lg-2 col-md-6 col-sm-12">
                     <label for="" class="d-flex align-items-center">Application</label>
                     <angular2-multiselect [data]="showApplication" [(ngModel)]="selectedApplication"
                        [settings]="dropdownSetting2" formControlName="Application"
                        (onSelect)="onApplicationSelect($event)" (onDeSelect)="onApplicationSelect($event)"
                        fixSearchBug>
                     </angular2-multiselect>
                  </div>
               </div>

               <div class="row justify-content-start align-items-center mb-2 mt-2 zIndexUp">
                  <ul class="list-unstyled action-tool-bar col-md-12 col-sm-12 mb-0">
                     <li> <button type="submit" href="javascript:void(0);" class="btn btn-sm btn-light-info fs-12"
                           (click)="onSubmit()" [disabled]="multiClick">
                           <span class="mdi mdi-content-save ml-1"></span>Save</button>
                     </li>
                  </ul>
               </div>
            </form>
         </div>
      </div>
   </div>
</div>

<!-- Duplicate modal-->
<div class="modal fade" bsModal #duplicate="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
   aria-labelledby="dialog-static-name">
   <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content animated zoomIn">
         <div class="modal-header">
            <h4 id="dialog-static-name" class="modal-title pull-left">Duplicate Inquiry </h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="duplicate.hide()">
               <span aria-hidden="true">&times;</span>
            </button>
         </div>
         <div class="modal-body">
            <form action="">
               <div class="form-row animated fadeIn">
                  <div class="col-lg-12 col-md-12">
                     <div class="form-group mb-0 text-center ">
                        <i class="mdi mdi-checkbox-multiple-blank-outline mdi-48px text-info d-block"></i>
                        <label>Are you sure, you want to Duplicate ?</label>
                     </div>
                  </div>
               </div>
            </form>
         </div>
         <div class="modal-footer">
            <a href="javascript:void(0);" class="btn btn-sm btn btn-info"
               (click)="Duplicate(); duplicate.hide()">Yes</a>
            <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2" (click)="duplicate.hide()">Close</a>
         </div>
      </div>
   </div>
</div>

<!-- Multi Duplicate-->
<div class="modal fade" bsModal #multiDuplicate="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
   aria-labelledby="dialog-static-name">
   <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content animated zoomIn">
         <div class="modal-header">
            <h4 id="dialog-static-name" class="modal-title pull-left">Multi Duplicate Inquiry</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="multiDuplicate.hide()">
               <span aria-hidden="true">&times;</span>
            </button>
         </div>
         <div class="modal-body">
            <form action="">
               <div class="form-row animated fadeIn">
                  <div class="col-lg-12 col-md-12">
                     <div class="form-group mb-0 text-center ">
                        <i class="mdi mdi-checkbox-multiple-blank-outline mdi-48px text-info d-block"></i>
                        <label>Are you sure, you want to Multi Duplicate ?</label>
                     </div>
                  </div>
               </div>
            </form>
         </div>
         <div class="modal-footer">
            <a href="javascript:void(0);" class="btn btn-sm btn btn-info"
               (click)="Duplicate(); multiDuplicate.hide()">Yes</a>
            <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
               (click)="multiDuplicate.hide()">Close</a>
         </div>
      </div>
   </div>
</div>

<!--Item Vat% Info-->
<div class="modal fade" bsModal #vatDocument="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
   role="dialog" aria-labelledby="dialog-static-name">
   <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content animated zoomIn">
         <div class="modal-header">
            <h4 id="dialog-static-name" class="modal-title pull-left">vat Result</h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="vatDocument.hide()">
               <span aria-hidden="true">&times;</span>
            </button>
         </div>
         <div class="modal-footer">
            <button href="javascript:void(0);" class="btn btn-sm btn btn-info">VatResult</button>
            <input #showvat (click)="vatResult.show()" type="hidden">
            <a href="javascript:void(0);" class="btn btn-sm btn btn-secondary ml-2"
               (click)="vatDocument.hide()">Close</a>
         </div>
      </div>
   </div>
</div>

<div class="modal fade" bsModal #vatResult="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
   role="dialog" aria-labelledby="dialog-static-name">
   <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content animated zoomIn">
         <div class="modal-header">
            <h4 id="dialog-static-name" class="modal-title pull-left">Item Vat% Info</h4>
         </div>
         <div class="modal-body">
            <form action="">
               <div class="form-row animated fadeIn">
                  <div class="col-lg-12 col-md-12">
                     <div class="form-group mb-0">
                        <label>Vat Rate should be same for same ItemCode
                        </label>
                     </div>
                  </div>
               </div>

               <div class="form-row animated fadeIn">
                  <div class="col-lg-12 col-md-12">
                     <div class="table-responsive" style="max-height: 300px;">
                        <table class="table mb-0" aria-hidden="true">
                           <tbody>
                              <tr *ngFor="let item of dataarray; let i = index">
                                 <td>Row No. {{item.RowNo}}</td>
                                 <td>{{item.ItemCode}}</td>
                                 <td>{{item.VatRate}}</td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
               </div>
            </form>
         </div>

         <div class="modal-footer">
            <a href="javascript:void(0);" (click)="vatResult.hide(); vatDocument.hide();"
               class="btn btn-sm btn btn-info">OK</a>
         </div>
      </div>
   </div>
</div>

<!--Delete modal-->
<ng-template #deleteConfirm>
   <div class="modal-header">
      <h4 class="modal-title text-dark"><strong>Delete Product</strong></h4>
      <button type="button" class="close" (click)="decline(); modalRef.hide();" data-dismiss="modal"
         aria-label="Close"><span aria-hidden="true">&times;</span></button>
   </div>
   <div class="modal-body text-center">
      <p class="text-left mb-2"><strong>Item Code: {{Product}} </strong></p>
      <p class="text-left mb-2">Do you want to delete this Product ?</p>
   </div>
   <div class="modal-footer">
      <button type="button" class="btn btn-danger btn-sm" (click)="onDeleteRow(rowId, inqProductId); modalRef.hide();"
         [disabled]="delNameDel">Delete</button>
      <button type="button" class="btn btn-sm btn btn-secondary ml-2"
         (click)="decline(); modalRef.hide();">Cancel</button>
   </div>
</ng-template>

<!--MTI NO POP-UP-->
<div class="modal fade" bsModal #mtiResult="bs-modal" [config]="{backdrop: 'static', keyboard: false}" tabindex="-1"
   role="dialog" aria-labelledby="dialog-static-name">
   <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content animated zoomIn">
         <div class="modal-header">
            <h4 id="dialog-static-name" class="modal-title pull-left"><strong>MTI Information</strong></h4>
         </div>
         <div class="modal-body">
            <form action="">
               <div class="form-row animated fadeIn">
                  <div class="col-lg-12 col-md-12">
                     <div class="modal-body text-center">
                        <input #showmti (click)="mtiResult.show()" type="hidden">
                        <p class="text-left mb-2">{{errorMsg}}</p>
                        <p class="text-left mb-2">MTI Number - {{checkDelete}}</p>
                     </div>
                  </div>
               </div>
            </form>
         </div>
         <div class="modal-footer">
            <a href="javascript:void(0);" (click)="mtiResult.hide();" class="btn btn-sm btn btn-info">OK</a>
         </div>
      </div>
   </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>